import mock from "./mock";

import "./apps/chat";
import "./apps/patientList";

mock.onAny().passThrough();
